<template>
  <center>
    <div class="error-404">
      <h1>Error 404: Seite nicht gefunden</h1>
      <p>
        <a href="/">Zurück zur Startseite</a>
      </p>
    </div>
  </center>
</template>

<script>

  export default {
    name: 'NotFound'
  }

</script>

<style lang="scss" scoped>
  @import '@/scss/_variables.scss';

  center {
    margin: 15vw;
  }

  h1 {
    color: var(--border);
    font-size: 2em;
    padding-bottom: 20px;
  }

  .error-404 {
      padding-top: 50px;
  }


</style>